<script setup>
import { ref, watch } from 'vue';
import Empty from '@/components/Empty.vue';

const props = defineProps({
	loading: {
		type: Boolean,
		default: false
	},
	empty: {
		type: Boolean,
		default: false
	},
	background: {
		type: String,
		default: '#ffffff'
	}
});

// 对于加载状态，区分遮罩提示和内容占位两种情况
const firstLoadDone = ref(false);
const displayLoading = ref(false);
watch(
	() => props.loading,
	newVal => {
		if (firstLoadDone.value) return;

		if (newVal) {
			displayLoading.value = true;
		} else if (displayLoading.value) {
			displayLoading.value = false;
			firstLoadDone.value = true;
		}
	},
	{ immediate: true }
);
</script>

<template>
	<div v-loading="loading" class="module-state-box" :style="{ background: loading ? background : 'transparent' }">
		<div v-if="displayLoading" class="module-state-loading"></div>
		<Empty v-else-if="empty" />
		<div v-else class="module-state-content">
			<!-- 需要额外的节点嵌套，来避免样式隔离问题 -->
			<slot></slot>
		</div>
	</div>
</template>

<style lang="less" scoped>
.module-state-box {
	.module-state-loading {
		height: 200px;
	}
	.module-state-content {
		height: 100%;
	}
}
</style>
